import * as React from "react";
import { Price } from "../../../../../../../../../../Price/Price/Price.js";
import { PriceWithAffix } from "../../../../../../../../../../Price/PriceWithAffix/Price/PriceWithAffix/PriceWithAffix.js";
/* empty css                 */
const PriceDetail = ({
  originalPrice,
  discountedPrice,
  isCentAmount,
  priceSuffix
}) => {
  if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
    return /* @__PURE__ */ React.createElement("div", { className: "price-detail" }, /* @__PURE__ */ React.createElement(
      PriceWithAffix,
      {
        value: discountedPrice,
        isCentAmount,
        type: "new",
        "data-t": "price-discounted",
        size: "small",
        priceSuffix
      }
    ), /* @__PURE__ */ React.createElement(
      Price,
      {
        value: originalPrice,
        isCentAmount,
        type: "old",
        variant: "strikethrough",
        "data-t": "price-original",
        size: "small"
      }
    ));
  }
  return /* @__PURE__ */ React.createElement("div", { className: "price" }, /* @__PURE__ */ React.createElement(
    PriceWithAffix,
    {
      value: originalPrice,
      isCentAmount,
      type: "full",
      "data-t": "price-original",
      size: "small",
      priceSuffix
    }
  ));
};
export {
  PriceDetail
};
//# sourceMappingURL=PriceDetail.js.map
